import api from "@/lib/api";
import { ALLOWED_UPLOAD_EXTENSIONS, MAX_UPLOAD_BYTES, UPLOAD_CHUNK_BYTES } from "@/lib/constants";

export function validateFile(file) {
  const ext = file.name.split(".").pop()?.toLowerCase();
  if (!ALLOWED_UPLOAD_EXTENSIONS.includes(ext)) {
    return "Unsupported file type. Allowed: PDF, Word, Excel, PowerPoint, CSV, text and images.";
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    return `"${file.name}" is larger than the 25 MB limit.`;
  }
  return null;
}

export async function uploadFile(file, onProgress) {
  const totalChunks = Math.max(1, Math.ceil(file.size / UPLOAD_CHUNK_BYTES));
  const init = await api.post("/uploads/init", {
    filename: file.name,
    content_type: file.type || "application/octet-stream",
    size: file.size,
    total_chunks: totalChunks,
  });
  const uploadId = init.data.upload_id;

  for (let index = 0; index < totalChunks; index += 1) {
    const slice = file.slice(index * UPLOAD_CHUNK_BYTES, (index + 1) * UPLOAD_CHUNK_BYTES);
    const body = new FormData();
    body.append("upload_id", uploadId);
    body.append("index", String(index));
    body.append("chunk", slice, `${file.name}.part${index}`);
    await api.post("/uploads/chunk", body);
    onProgress?.(Math.round(((index + 1) / totalChunks) * 95));
  }

  const done = await api.post("/uploads/complete", { upload_id: uploadId, total_chunks: totalChunks });
  onProgress?.(100);
  return done.data;
}
